import React from 'react';
import { OrganisationAssignmentDto } from 'models/dtoTypes';
import { date2str } from 'utils/date';
import { styled } from '@mui/material/styles';
import ResourceDetailContainer, { ITab } from 'kosmos/components/ResourceDetailContainer';
import { RouteComponentProps, withRouter } from 'react-router';
import { GetOrganisationAssignment } from 'services/organisationAssignment';
import { useTranslation } from 'react-i18next';

const PREFIX = 'SmartGovernanceDetailPage';

const classes = {
  root: `${PREFIX}-root`,
  pageHeader: `${PREFIX}-pageHeader`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(5),
  width: '100%',

  [`& .${classes.pageHeader}`]: {
    width: '100%',
    position: 'relative',

    '& > button': {
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },
}));

function SmartGovernanceDetailPage(props: RouteComponentProps<{ id: string }>): JSX.Element {
  const id = props.match.params.id;
  console.log(id);
  const [tabId, setTabId] = React.useState('details');
  const { t } = useTranslation('default');

  const generateTabs = (): ITab<OrganisationAssignmentDto>[] => [
    {
      id: 'details',
      title: t('details'),
      getUiSchema: () => ({
        fields: [
          {
            label: 'Id',
            name: 'id',
            readonly: true,
            widget: 'text',
          },
          {
            label: t('organisation'),
            name: 'organisationId',
            readonly: false,
            formatter: (organisationId: string, attributes: OrganisationAssignmentDto) =>
              attributes.organisationId,
            widget: 'organisationSelector',
          },
          {
            label: t('company-id'),
            name: 'kosmosCompanyId',
            readonly: true,
            widget: 'text',
          },
          {
            label: t('assigner'),
            name: 'assignerId',
            readonly: true,
            widget: 'text',
          },
          {
            label: t('accepted-by'),
            name: 'acceptUserId',
            readonly: true,
            widget: 'text',
          },
          {
            label: t('created-at'),
            formatter: (datestr: string) => date2str(datestr, 'DD MMM YYYY, HH:mm'),
            name: 'created',
            readonly: true,
            widget: 'text',
          },
          {
            label: t('last-updated-at'),
            name: 'updated',
            formatter: (datestr: string) => date2str(datestr, 'DD MMM YYYY, HH:mm'),
            readonly: true,
            widget: 'text',
          },
        ],
      }),
    },
  ];

  const handleFetch = async (): Promise<OrganisationAssignmentDto> => {
    return await GetOrganisationAssignment(id);
  };

  // const handleUpdate = async (attrs: { organisationId?: string }): Promise<OrganisationAssignmentDto> => {
  //   const user = await UpdateUser(id, attrs);
  //   return user;
  // };

  return (
    <Root>
      <ResourceDetailContainer
        tabs={generateTabs()}
        breadcrumbText={t('smart-governances')}
        breadcrumbUrl="/smart_governances"
        onTabChanged={setTabId}
        onFetch={handleFetch}
        //onUpdate={handleUpdate}
        currentTabId={tabId}
        displayNameKey="email"
      />
    </Root>
  );
}

export default withRouter(SmartGovernanceDetailPage);
